import React, { useState, useEffect } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";
import { Container } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Modal from "react-bootstrap/Modal";
import ScrollToTop from "./ScrollToTop";

import log01 from "../assets/img/logo.png";
import downloadepdficon from "../assets/img/download-pdf-icon.svg";

import brochurePdf1 from "../assets/img/pdf/elixir-brochur.pdf";
import brochurePdf2 from "../assets/img/pdf/elixir-printing.pdf";
import brochurePdf3 from "../assets/img/pdf/elixir-arsign.pdf";
import brochurePdf4 from "../assets/img/pdf/elixir-label.pdf";
import brochurePdf5 from "../assets/img/pdf/elixir-exhibitions.pdf";
import brochurePdf6 from "../assets/img/pdf/elixir-signages.pdf";
import brochurePdf7 from "../assets/img/pdf/elixir-safety.pdf";
import brochurePdf8 from "../assets/img/pdf/elixir-packaging.pdf";
import brochurePdf9 from "../assets/img/pdf/elixir-gifts.pdf";
import brochurePdf10 from "../assets/img/pdf/elixir-restaurant.pdf";
import brochurePdf11 from "../assets/img/pdf/elixir-digital-signages.pdf";

// ✅ Define paths outside
const servicesPaths = [
  "/Brandingandgraphicdesign",
  "/Signageoutdoor",
  "/Signageindoor",
  "/Signageindustrial",
  "/Digitalsignage",
  "/Printingservices",
  "/Eventservices",
  "/Exhibitionservices",
  "/Webdesignservices",
  "/Socialmediamarketing",
  "/Corporateservices",
  "/Tradingservices",
];
const aboutPaths = ["/Aboutus", "/Qualitypolicy", "/Facility", "/Certificates", "/Corevalues"];
const itSolutionsPaths = ["/ITsolutions"];
const signagePaths = ["/Signageoutdoor", "/Signageindoor", "/Signageindustrial", "/Digitalsignage"];

function Navigation() {
  const [show, setShow] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [navbar, setNavbar] = useState(false);

  const [showAbout, setShowAbout] = useState(false);
  const [showServices, setShowServices] = useState(false);
  const [showIT, setShowIT] = useState(false);
  const [showSignageSubmenu, setShowSignageSubmenu] = useState(false);

  const location = useLocation();

  const isServicesActive = servicesPaths.includes(location.pathname);
  const isAboutActive = aboutPaths.includes(location.pathname);
  const isITSolutionsActive = itSolutionsPaths.includes(location.pathname);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const changeBackground = () => setNavbar(window.scrollY >= 10);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Close menus on navigation
  useEffect(() => {
    setShowAbout(false);
    setShowServices(false);
    setShowIT(false);
    setExpanded(false);
    setShowSignageSubmenu(false);
  }, [location.pathname]);

  useEffect(() => {
    window.addEventListener("scroll", changeBackground);
    return () => window.removeEventListener("scroll", changeBackground);
  }, []);

  const handleNavClick = () => {
    setExpanded(false);
    setShowAbout(false);
    setShowServices(false);
    setShowIT(false);
    setShowSignageSubmenu(false);
  };

  return (
    <div className="navigation fixed-top">
      <ScrollToTop />
      <Navbar expand="lg" expanded={expanded} className={navbar ? "navbar active" : "navbar"}>
        <Container>
          <Navbar.Brand as={Link} to="/" onClick={handleNavClick}>
            <img id="one" src={log01} alt="Elixir" />
            <img id="two" src={log01} alt="Elixir" />
          </Navbar.Brand>

          <Navbar.Toggle onClick={() => setExpanded(!expanded)} />
          <Navbar.Collapse>
            <Nav className="ms-auto navmenuCenter">
              <NavLink className="nav-link" to="/" onClick={handleNavClick} end>
                Home
              </NavLink>

              {/* About Dropdown */}
              <NavDropdown
                title="About"
                className={`dropMenus dropdown ${isAboutActive ? "active" : ""}`}
                show={showAbout}
                onToggle={(isOpen) => setShowAbout(isOpen)}
              >
                <NavDropdown.Item as={Link} to="/Aboutus" onClick={handleNavClick}>
                  Company Profile
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/Qualitypolicy" onClick={handleNavClick}>
                  Quality Policy
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/Facility" onClick={handleNavClick}>
                  Facility
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/Certificates" onClick={handleNavClick}>
                  Certificates
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/Corevalues" onClick={handleNavClick}>
                  Core Values
                </NavDropdown.Item>
              </NavDropdown>

              {/* Services Dropdown */}
              <NavDropdown
                title="Services"
                className={`dropMenus dropdown ${isServicesActive ? "active" : ""}`}
                show={showServices}
                onToggle={(isOpen) => setShowServices(isOpen)}
              >
                <NavDropdown.Item as={Link} to="/Brandingandgraphicdesign" onClick={handleNavClick}>
                  Branding & Graphic Design
                </NavDropdown.Item>

                {/* Signage Submenu */}
                <div
                  className="dropdown-item signage-toggle"
                  onClick={(e) => {
                    e.stopPropagation();
                    setShowSignageSubmenu(!showSignageSubmenu);
                  }}
                >
                  <span>Signage</span>
                </div>
                <div className={`submenu ${showSignageSubmenu ? "show" : ""}`}>
                  <Link className="dropdown-item" to="/Signageoutdoor" onClick={handleNavClick}>
                    - Outdoor
                  </Link>
                  <Link className="dropdown-item" to="/Signageindoor" onClick={handleNavClick}>
                    - Indoor
                  </Link>
                  <Link className="dropdown-item" to="/Signageindustrial" onClick={handleNavClick}>
                    - Industrial
                  </Link>
                  <Link className="dropdown-item" to="/Digitalsignage" onClick={handleNavClick}>
                    - Digital
                  </Link>
                </div>

                <NavDropdown.Item as={Link} to="/Printingservices" onClick={handleNavClick}>
                  Printing & Packaging
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/Eventservices" onClick={handleNavClick}>
                  Event Management
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/Exhibitionservices" onClick={handleNavClick}>
                  Exhibition Booths
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/Webdesignservices" onClick={handleNavClick}>
                  Website Design & Developments
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/Corporateservices" onClick={handleNavClick}>
                  Corporate Gifts
                </NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/Tradingservices" onClick={handleNavClick}>
                  General Trading
                </NavDropdown.Item>
              </NavDropdown>

              <NavLink className="nav-link" to="/ITsolutions" onClick={handleNavClick}>
                IT Solutions
              </NavLink>
              <NavLink className="nav-link" to="/Clients" onClick={handleNavClick}>
                Clients
              </NavLink>
              <NavLink className="nav-link" to="/Jobs" onClick={handleNavClick}>
                Jobs
              </NavLink>
              <NavLink className="nav-link" to="/Contact" onClick={handleNavClick}>
                Contact
              </NavLink>
            </Nav>

            {/* Brochure Button */}
            <Link onClick={handleShow} className="ms-auto brochureBtn">
              <img
                src={require("../assets/img/brochure-img-1.jpg")}
                className="img-fluid"
                alt="elixir"
              />
            </Link>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Brochure Modal */}
      <Modal size="lg" show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title className="brocureBox-h4">Brochure</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="brocureBox">
            {[
              brochurePdf1,
              brochurePdf2,
              brochurePdf3,
              brochurePdf4,
              brochurePdf5,
              brochurePdf6,
              brochurePdf7,
              brochurePdf8,
              brochurePdf9,
              brochurePdf10,
              brochurePdf11,
            ].map((pdf, idx) => (
              <a
                key={idx}
                href={pdf}
                className="brocureBox-file"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="brocureBox-img">
                  <img
                    src={require(`../assets/img/elixir-${[
                      "brochur",
                      "printing",
                      "arsign",
                      "label",
                      "exhibitions",
                      "signages",
                      "safety",
                      "packaging",
                      "gifts",
                      "restaurant",
                      "digital",
                    ][idx]}-img-1.jpg`)}
                    className="brocureBox-img-main img-fluid"
                    alt="elixir"
                  />
                  <img src={downloadepdficon} className="brocureBox-img-download" alt="download" />
                </div>
                <h4>
                  {[
                    "Brochure",
                    "Printing",
                    "ARsign",
                    "Label",
                    "Exhibitions",
                    "Signages",
                    "Safety",
                    "Packaging",
                    "Gifts",
                    "Restaurant",
                    "Digital",
                  ][idx]}
                </h4>
              </a>
            ))}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default Navigation;